import { PricePlanVisibility } from 'dy-frontend-http-repository/lib/data/enums';

const pricePlanVisibilityInformation: { [pricePlanVisibility in PricePlanVisibility]: string } = {
    [PricePlanVisibility.INTERNAL]: 'Internal',
    [PricePlanVisibility.PUBLIC]: 'Public',
};

export default pricePlanVisibilityInformation;
